document.addEventListener('DOMContentLoaded', function () {


  fwLog('Seite geladen - Starte Überprüfung auf der Collection-Seite');

  // Funktion, um den aktuellen Warenkorbstatus im localStorage zu speichern
  function updateLocalStorage(cartItems) {
    const cartData = {};
    cartItems.forEach(item => {
      cartData[item.product_id] = item.quantity;
    });
    localStorage.setItem('cartData', JSON.stringify(cartData));
  }

  // Funktion, um den localStorage auszulesen
  function getLocalStorageData() {
    const cartData = localStorage.getItem('cartData');
    return cartData ? JSON.parse(cartData) : {};
  }

  // Funktion, um Änderungen zu prüfen und Buttons zurückzusetzen
  function resetUIForRemovedProducts(currentCartItems) {
    const storedCartData = getLocalStorageData();
    const currentProductIds = currentCartItems.map(item => item.product_id);

    // Identifizieren der Produkte, die entfernt wurden
    Object.keys(storedCartData).forEach(productId => {
      if (!currentProductIds.includes(parseInt(productId))) {
        fwLog(`Produkt entfernt: ${productId}`);

        // Zurücksetzen der Buttons und Input-Felder
        const addToCartButtons = document.querySelectorAll(`button[data-product-id="${productId}"]`);
        const quantityInputs = document.querySelectorAll(`input[data-product-id="${productId}"]`);

        addToCartButtons.forEach(button => {
          button.disabled = false;
          button.classList.remove('disabled');
          button.textContent = 'In den Warenkorb';
        });

        quantityInputs.forEach(input => {
          input.max = 10; // Standardwert
          input.disabled = false;
          input.value = input.min || 1;
        });
      }
    });
  }

  // Funktion zur Überprüfung der Produkte im Warenkorb
// Funktion zur Überprüfung der Produkte im Warenkorb
function checkCartQuantities() {
  fwLog('Warenkorb wird abgerufen...');

  // Referenz zum Haupt-Produkt-Container auf der Seite
  const mainProductsContainer = document.querySelector('custom-pagination.main-products-grid');

  // Wenn der Haupt-Container nicht gefunden wird, brechen wir ab
  if (!mainProductsContainer) {
    fwLog('Fehler: Haupt-Produkt-Container (custom-pagination.main-products-grid) nicht gefunden.');
    return;
  }

  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Fehler beim Abrufen des Warenkorbs: ' + response.status);
      }
      return response.json();
    })
    .then(cart => {
      fwLog('Warenkorbdaten erfolgreich abgerufen:', cart);

      resetUIForRemovedProducts(cart.items);
      updateLocalStorage(cart.items);

      // Durch alle Produkte im Warenkorb iterieren
      cart.items.forEach(item => {
        const productId = item.product_id;
        const totalQuantityInCart = item.quantity;

        const addToCartButtons = mainProductsContainer.querySelectorAll(`button[data-product-id="${productId}"]`);
        const quantityInputs = mainProductsContainer.querySelectorAll(`input[data-product-id="${productId}"]`);
        const priceElement = mainProductsContainer.querySelector(`.price__current[data-product-id="${productId}"]`);

        let price = null;
        if (priceElement) {
          const priceText = priceElement.textContent.trim();
          price = parseFloat(priceText.replace(/[^0-9,.-]+/g, '').replace(',', '.'));
          fwLog(`price: ${price}`);
        } else {
          fwLog(`Kein Preis gefunden im Haupt-Container für Produkt-ID: ${productId}`);
        }

        const firstButton = addToCartButtons[0];
        const maxOrderQuantity = firstButton ? parseInt(firstButton.dataset.maxOrderQuantity) || 10 : 10; // Fallback, falls kein Button gefunden wird

        const remainingQuantity = maxOrderQuantity - totalQuantityInCart;
        fwLog(`remainingQuantity: ${remainingQuantity}`);
        // === ENDE DER WICHTIGEN ÄNDERUNG ===


        if (addToCartButtons.length === 0 && quantityInputs.length === 0) {
          fwLog(`Kein Button oder Input-Feld im Haupt-Container gefunden für Produkt-ID: ${productId}`);
          return;
        }


        addToCartButtons.forEach(button => {
          if (remainingQuantity <= 0 || price === 0) {
            button.disabled = true;
            button.classList.add('disabled');
            button.textContent = price === 0 ? 'Nicht verfügbar' : 'Maximum erreicht';
          } else {
            button.disabled = false;
            button.classList.remove('disabled');
            button.textContent = 'In den Warenkorb';
          }
        });

        quantityInputs.forEach(input => {
          if (remainingQuantity > 0 && price !== 0) {
            input.max = remainingQuantity;
            input.disabled = false;
            input.value = input.min || 1;
          } else {
            input.max = 0;
            input.disabled = true;
            input.value = input.min || 1;
          }
        });
      });
    })
    .catch(error => {
      fwLog('Fehler beim Abrufen des Warenkorbs:', error);
    });

    fwSetTaxPreference();
}

  // Initiale Überprüfung beim Laden der Seite
  checkCartQuantities();

  // Collection-Handler in LS setzen
  fwSetCollectionBreadcrumb();

  // assets/deine-globale-fetch-handler.js

  (function() {
    const originalFetch = window.fetch;

    // Referenzen zu Modal-Elementen außerhalb des Interceptors für Effizienz
    const modal = document.getElementById('fwCrosssellModal');
    const overlay = document.getElementById('fwCrosssellModal-overlay');
    const contentContainer = document.getElementById('fwCrosssellModal-content');

    // Hilfsfunktionen für Modalsteuerung
    const openModal = () => {
        if (modal && overlay) {
            overlay.classList.add('show');
            modal.classList.add('show');
            document.body.style.overflow = 'hidden';
        }
    };

    const closeModal = () => {
        if (modal && overlay) {
            modal.classList.remove('show');
            overlay.classList.remove('show');
            document.body.style.overflow = '';
            //contentContainer.innerHTML = ''; // Auskommentiert gelassen, wie in deiner Vorlage
        }
    };

    // Event Listener für Modal-Schließen einmalig einrichten
    if (overlay) overlay.addEventListener('click', closeModal);
    document.addEventListener('click', (event) => {
        if (event.target.matches('.js-close-cross-sell-modal')) {
            closeModal();
        }
    });

    window.fetch = async function() {
        const fetchArgs = arguments;
        const url = fetchArgs[0];
        const options = fetchArgs[1] || {};

        // Führe den ursprünglichen Fetch-Request zuerst aus
        const response = await originalFetch.apply(this, fetchArgs);
        const clonedResponse = response.clone();

        // --- Bestehende Logik für Warenkorb-/Kollektions-/Such-Änderungen ---
        if (typeof url === 'string' && (url.includes('/cart/change') || url.includes('/cart/add') || url.includes('/cart/update'))) {
            fwLog('Fetch für `/cart`-Aktion erkannt - Überprüfung der Produkte wird durchgeführt');
            setTimeout(() => {
                if (typeof checkCartQuantities === 'function') checkCartQuantities();
                if (typeof initializeWishlistWithQuantity === 'function') initializeWishlistWithQuantity();
            }, 500);
        }

        if (typeof url === 'string' && (url.includes('/collections') || url.includes('/search'))) {
            fwLog('Fetch für `/collections`- oder `/search`-Aktion erkannt - Überprüfung der Produkte wird durchgeführt');
            setTimeout(() => {
                if (typeof checkCartQuantities === 'function') checkCartQuantities();
                if (typeof initializeWishlistWithQuantity === 'function') initializeWishlistWithQuantity();
            }, 500);
        }
        // -------------------------------------------------------------

        // --- Logik für das Cross-Selling Modal nach /cart/add ---
        if (typeof url === 'string' && url.includes('/cart/add')) {
            let productHandle = null;
            let quantity = '1';
            let hasCrosssellsValue = '0'; // Standardwert für _has_crosssells

            if (options.body instanceof FormData) {
              // 1. Variante-ID auslesen (das ist die ID, die an Shopify geht)
              let variantId = options.body.get('id');
              
              // 2. Das dazugehörige Formular im Quelltext suchen
              // Wir suchen das Input-Feld mit der ID und gehen zum umschließenden <form> Tag
              let formElement = document.querySelector(`form input[name="id"][value="${variantId}"]`)?.closest('form');

              // 3. Werte initialisieren
              productHandle = null;
              hasCrosssellsValue = '0';
              quantity = options.body.get('quantity') || '1'; // Quantity bleibt im FormData

              // 4. Wenn wir das Formular gefunden haben, lesen wir die Data-Attribute aus
              if (formElement) {
                  // .dataset wandelt 'data-crosssell' in 'crosssell' und 'data-producthandle' in 'producthandle' um
                  productHandle = formElement.dataset.producthandle;
                  hasCrosssellsValue = formElement.dataset.crosssell || '0';
              }

              fwLog(`Cross-Sell productHandle (extracted): ${productHandle}, Quantity (extracted): ${quantity}, Has Crosssells (extracted): ${hasCrosssellsValue}`);
              
              // WICHTIG: Die .delete() Befehle fliegen komplett raus! 
              // options.body ist bereits zu 100% sauber und bereit für Shopify.
            } else {
                // Wenn der Body nicht FormData ist, loggen wir das und setzen die Werte auf null
                fwLog('Debug: Unerwarteter Body-Typ für /cart/add - Nicht FormData. Modal-Logik wird übersprungen.');
                productHandle = null; // Stellt sicher, dass die nachfolgende if-Bedingung fehlschlägt
                // quantity und hasCrosssellsValue bleiben bei ihren Standardwerten oder werden nicht verwendet
            }

            // Nur fortfahren, wenn ein Produkt-Handle gefunden wurde,
            // Modal-Elemente existieren UND _has_crosssells den Wert '1' hat
            if (productHandle && modal && overlay && contentContainer && hasCrosssellsValue === '1') {
                fwLog('Cross-Sell-Modal-Logik wird ausgeführt...');
                contentContainer.innerHTML = '<div class="loading-spinner"></div>';
                openModal();

                const sectionUrl = `/products/${productHandle}?section_id=fw_crosssell-dymamic-content`;

                try {
                    const sectionResponse = await fetch(sectionUrl);
                    const html = await sectionResponse.text();
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;

                    // Die Prüfung auf #no-cross-sells kann als zusätzliche Absicherung dienen
                    if (tempDiv.querySelector('#no-cross-sells')) {
                        fwLog('Produkt hinzugefügt, aber #no-cross-sells im geladenen Inhalt gefunden. Modal wird geschlossen.');
                        closeModal();
                    } else {
                        contentContainer.innerHTML = html;

                        const inputs = contentContainer.querySelectorAll('input[name="quantity"]');
                        inputs.forEach(input => {
                            input.value = quantity;
                        });

                        const scripts = contentContainer.querySelectorAll('script');
                        scripts.forEach(script => {
                            const newScript = document.createElement('script');
                            if (script.src) newScript.src = script.src;
                            if (script.hasAttribute('defer')) newScript.defer = true;
                            if (script.hasAttribute('async')) newScript.async = true;
                            document.body.appendChild(newScript);
                            script.remove(); // Entferne das Original-Script-Tag aus dem tempDiv
                        });

                        fwLog('Cross-Selling Modal Inhalt geladen und angezeigt');
                    }
                } catch (error) {
                    console.error('Fehler beim Laden des Cross-Sell-Modals:', error);
                    closeModal();
                }
            } else if (hasCrosssellsValue !== '1') {
                fwLog('Debug: _has_crosssells ist nicht "1". Cross-Sell-Modal wird nicht geöffnet.');
            } else {
                fwLog('Debug: Kein Produkt-Handle für Cross-Sell-Modal gefunden oder Modal-Elemente fehlen. Modal wird nicht geöffnet.');
            }
        }
        // -------------------------------------------------------------

        return clonedResponse;
    };
  })();




});




function fwSetCollectionBreadcrumb() {
  if (!window.location.pathname.includes('/collections/')) return;

  document.querySelectorAll('.fwCardLink[data-collection]').forEach(link => {
    link.addEventListener('click', () => {
      localStorage.setItem('fwLastCollection', link.dataset.collection);
    });
  });
}


// ──────────────────────────────────────────────────────────────────────────
// Collection-Anfrage-Trigger: schreiben in die zentrale Anfrageliste
// (fwB2bAnfrageliste in fw__css-base.js.liquid) und oeffnen das geteilte
// Modal aus fw__js-anfrage-modal.js im 'collection'-Modus.
// ──────────────────────────────────────────────────────────────────────────

// Items fuer renderItems(): Wunschartikel oben (neueste zuerst), dann Produkte.
function fwCollectionGetAnfrageItems() {
  const d = (typeof fwAnfrageGet === 'function') ? fwAnfrageGet() : {};
  const all = Object.values(d);
  const wish = all.filter(i => i.isFree).reverse();
  const prod = all.filter(i => !i.isFree).reverse();
  return [...wish, ...prod];
}

function fwCollectionUpdateItem(id, patch) {
  if (typeof fwAnfrageGet !== 'function' || typeof fwAnfrageSet !== 'function') return;
  const d = fwAnfrageGet();
  const key = String(id);
  if (!d[key]) return;
  Object.assign(d[key], patch);
  fwAnfrageSet(d);
}

function fwCollectionRemoveItem(id) {
  if (typeof fwAnfrageRemove === 'function') fwAnfrageRemove(id);
}

function fwCollectionOpenModal(subject, title) {
  if (!window.fwAnfrageModal) { console.error('fwAnfrageModal-Modul nicht geladen'); return; }
  window.fwAnfrageModal.open({
    mode: 'collection',
    subject,
    title,
    getItems:   fwCollectionGetAnfrageItems,
    updateItem: fwCollectionUpdateItem,
    removeItem: fwCollectionRemoveItem,
    onSuccess: () => {
      // Submit erfolgreich: zentrale Anfrageliste leeren und Counter aktualisieren.
      localStorage.removeItem('fwB2bAnfrageliste');
      if (typeof fwAnfrageUpdateCount === 'function') fwAnfrageUpdateCount();
    },
    showAddMore: true,
    onAddMore: fwCollectionAddMore
  });
}

// Klick auf "+ weitere Artikel hinzufuegen" im Collection-Modal:
// Items liegen bereits im gemeinsamen Storage fwB2bAnfrageliste — anders als
// auf der PDP ist keine Item-Uebernahme noetig. Nur DataLayer + Navigation.
function fwCollectionAddMore() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'collection_request_add_more' });
  window.location.href = '/collections/b2b';
}

// Sold-out-Klick auf Produktkarte: legt das Variant in die Anfrageliste (via
// bestehende fwAnfrageAdd, feuert b2b_collection_request_product_added) und
// oeffnet danach das Modal mit Betreff "Lieferzeitanfrage".
function fwCollectionTriggerLieferzeitanfrage(btn) {
  const vid = btn.dataset.variantId;
  if (!vid) { console.error('Sold-out-Trigger ohne data-variant-id', btn); return; }
  if (typeof fwAnfrageAdd === 'function') {
    fwAnfrageAdd({
      variantId:    vid,
      sku:          btn.dataset.sku || '',
      productTitle: btn.dataset.productTitle || '',
      variantTitle: btn.dataset.variantTitle || '',
      variantLabel: btn.dataset.variantLabel || btn.dataset.variantTitle || '',
      image:        btn.dataset.image || '',
      priceCents:   btn.dataset.priceCents || 0,
      qty:          1,
      step:         1,
      source:       'collection'
    });
  }
  fwCollectionOpenModal('Lieferzeitanfrage', 'Lieferzeitanfrage');
}

// Promo-Card-Klick "Sie suchen etwas Bestimmtes?": legt einen leeren
// Wunschartikel an und oeffnet das Modal mit Betreff "Wunschartikel-Anfrage".
// Anschliessend wird der neu erzeugte Eintrag im Modal fokussiert.
function fwCollectionTriggerWunschArtikel() {
  if (typeof fwAnfrageAddWish !== 'function') {
    console.error('fwAnfrageAddWish nicht verfuegbar — ist fw__css-base.js.liquid geladen?');
    return;
  }
  const freeId = fwAnfrageAddWish();
  fwCollectionOpenModal('Wunschartikel-Anfrage', 'Wunschartikel-Anfrage');
  setTimeout(() => {
    const newEl = document.querySelector(`#fwAnfrageItemsList .fw-anf-wish-item__name--editable[data-free-id="${freeId}"]`);
    if (newEl) { newEl.focus(); newEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }, 150);
}


/* document.querySelector('.qty-input__input').addEventListener('change', (e) => {

  fwLog('Input-Event ausgelöst');

  const fwInput = e.target;
  const fwMax = Number(fwInput.max);
  if (fwInput.value > fwMax) {
    fwInput.value = fwMax;
    alert(`Maximalwert ${fwMax} erreicht.`);
  }
}); */